import * as React from 'react'
import { DriverCardModel } from '@/app/models'
import TableRadio from '@/modules/drivers/shared/tableItems/TableRadio'
import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'
import useFormatDate from '@/modules/drivers/hooks/useFormatDate'

export const DriverCardsRow = ({
  card,
  selectedIds,
  toggleId,
}: {
  card: DriverCardModel | any
  selectedIds: number[]
  toggleId: (id: number, checked: boolean) => void
}) => {
  const { formatDate } = useFormatDate()

  const [isHovered, setIsHovered] = React.useState(false)

  const isAnyChecked = selectedIds.length > 0
  const isChecked = selectedIds.includes(card?.driverCardId)

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

  return (
    <tr
       className={`notches-border--right tw-relative tw-w-fit tw-border-b  hover:tw-bg-primary/10 ${isChecked ? 'selected tw-bg-primary/10' : 'tw-bg-white'}`}
      onClick={() => {
        return toggleId(card?.driverCardId, !isChecked);
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <TableRadio
        isHovered={isHovered}
        background
        disabled={isAnyChecked && !isChecked}
        checked={isChecked}
        onClick={() => toggleId(card?.driverCardId, !isChecked)}
      />
      <TableTextRow size="small">{card?.cardNumber?.value}</TableTextRow>
      <TableTextRow size="small">
        {formatDate(card?.cardValidFrom) ?? '-'}
      </TableTextRow>
      <TableTextRow size="small">
        {formatDate(card?.cardValidTo) ?? '-'}
      </TableTextRow>
    </tr>
  )
}
